import { render, staticRenderFns } from "./ValidationOrderData.vue?vue&type=template&id=3111aaea"
import script from "./ValidationOrderData.vue?vue&type=script&lang=js"
export * from "./ValidationOrderData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports